export default __webpack_public_path__ + "static/media/chrome.06f3f882.svg";